var map = {
	"./fish1.png": 257,
	"./lily.png": 445,
	"./loginpage.png": 446,
	"./lucy.png": 752,
	"./luna.png": 742,
	"./max.png": 574,
	"./milo.png": 757,
	"./molly.png": 526,
	"./rabbit2.png": 522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;